import { ClipLoader, PropagateLoader } from "react-spinners";

const FullScreenLoader = () => {
  return (
    <div className="sw-container">
      <div className="loader_container">
        {/* <PropagateLoader color="#3b32bd" size={30} /> */}
        <ClipLoader color="#ff0461" loading size={80} speedMultiplier={1} />
      </div>
    </div>
  );
};

export default FullScreenLoader;
